import React, { useEffect } from 'react';
import pcMobileConfig from '@/hocs/pcMobileConfig';
import MobileReport from './components/MobileReport';
import PcReport from './components/PcReport';

interface IInfo {
  isReady: boolean;
}

interface IProps {
  isMobilePage: boolean;
}

/** GEO 报表页 */
const GEOReport: React.FC<IProps> = (props) => {
  const { isMobilePage } = props;


  return  isMobilePage ? (
      <MobileReport />
    ) : (
      <PcReport />
    )
};

export default pcMobileConfig(GEOReport, {
  pcBodyClass: 'geo_report_pc_body',
  mobileBodyClass: 'geo_report_mobile_body',
});
